import * as v from "./validate";

export interface GitInfo {
  version: string;
  commitHash: string;
  lastCommitTimeStr: string;
  lastCommitMs: number;
  branch?: string;
  User?: string;
}

export const GitInfo = {
  validator: new v.Validator(v.createValidate<GitInfo>()),
};
